import React, { useEffect, useState } from 'react';
import { Icon, Text } from '@fluentui/react';
import { DirectionsRenderer, InfoWindow, Marker } from '@react-google-maps/api';

import ItemRegistroTiempo from '../../models/ItemRegistroTiempo';

const getLatLng = (value: string) : google.maps.LatLng => {
    const valueArray : string[] = value.split(',');
    return new google.maps.LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
};

interface IGoogleMapMarkerComponentProps {
    workPart: ItemRegistroTiempo;
    selectedWorkPart?: ItemRegistroTiempo;
    selectedStart: boolean;
    onSelect: (workPart: ItemRegistroTiempo, start: boolean) => void;
};

const GoogleMapMarkerComponent = (props: IGoogleMapMarkerComponentProps) => {
    const [directions, setDirections] = useState<google.maps.DirectionsResult>();

    useEffect(() => {
        if (props.workPart.PosicionGPSInicio && props.workPart.PosicionGPSFinal) {
            const googleDataPositionInicio : google.maps.LatLng = getLatLng(props.workPart.PosicionGPSInicio);
            const googleDataPositionFin : google.maps.LatLng = getLatLng(props.workPart.PosicionGPSFinal);

            const directionsService : google.maps.DirectionsService = new google.maps.DirectionsService();
            directionsService.route({
                origin: googleDataPositionInicio,
                destination: googleDataPositionFin,
                travelMode: google.maps.TravelMode.DRIVING,
            }, (result: google.maps.DirectionsResult | null, status: google.maps.DirectionsStatus) => {
                if (result && status === google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                }
                else {
                    console.error(`error fetching directions ${result}`);
                }
            });
        }
        else {
            setDirections(undefined);
        }
    }, [props.workPart.PosicionGPSInicio, props.workPart.PosicionGPSFinal]);

    return (
        <>
            {
                props.workPart.PosicionGPSInicio ? (
                    <Marker 
                        position={getLatLng(props.workPart.PosicionGPSInicio)} 
                        onClick={() => {
                            props.onSelect(props.workPart, true);
                        }}>
                        {
                            (props.selectedStart && props.workPart.Id === props.selectedWorkPart?.Id) ? (
                                <InfoWindow position={getLatLng(props.workPart.PosicionGPSInicio)}>
                                    <>
                                        <Icon iconName='Play' />
                                        <br/>
                                        <Text variant="medium">
                                            <strong>
                                                {props.workPart.IdUsuario}
                                            </strong>
                                        </Text>
                                        <br/>
                                        <Text>
                                            {props.workPart.CodigoCliente}
                                        </Text>
                                        <br/>
                                        <Text>
                                            OT: {props.workPart.IdOrden}
                                        </Text>
                                        <br/>
                                        <Text variant="xSmall">
                                            {props.workPart.Inicio}
                                        </Text>
                                        <br/>
                                        <Text>
                                            {props.workPart.Descripcion}
                                        </Text>
                                    </>
                                </InfoWindow>
                            ) : (
                                null
                            )
                        }
                    </Marker>
                ) : (
                    null
                )
            }
            {
                props.workPart.PosicionGPSFinal ? (
                    <Marker 
                        position={getLatLng(props.workPart.PosicionGPSFinal)} 
                        onClick={() => {
                            props.onSelect(props.workPart, false);
                        }}>
                        {
                            (!props.selectedStart && props.workPart.Id === props.selectedWorkPart?.Id) ? (
                                <InfoWindow position={getLatLng(props.workPart.PosicionGPSFinal)}>
                                    <>
                                        <Icon iconName='Pause' />
                                        <br/>
                                        <Text variant="medium">
                                            <strong>
                                                {props.workPart.IdUsuario}
                                            </strong>
                                        </Text>
                                        <br/>
                                        <Text>
                                            {props.workPart.CodigoCliente}
                                        </Text>
                                        <br/>
                                        <Text>
                                            OT: {props.workPart.IdOrden}
                                        </Text>
                                        <br/>
                                        <Text variant="xSmall">
                                            {props.workPart.Fin}
                                        </Text>
                                        <br/>
                                        <Text>
                                            {props.workPart.Descripcion}
                                        </Text>
                                    </>
                                </InfoWindow>
                            ) : (
                                null
                            )
                        }
                    </Marker>
                ) : (
                    null
                )
            }
            {
                directions ? (
                    <DirectionsRenderer 
                        directions={directions}
                        options={{
                            polylineOptions: {
                                strokeColor: "#ed6d63",
                                strokeOpacity: 1,
                                strokeWeight: 5,
                            },
                            markerOptions: {
                                visible: false,
                            },
                        }} />
                ) : (
                    null
                )
            }
        </>
    );
};

export default GoogleMapMarkerComponent;
